import {
  setCookie as setCommonCookie,
  getCookie as getCommonCookie,
  removeCookie as removeCommonCookie,
  itemType,
} from 'MMT-UI/storages/client/cookieStorage';

export const getCookie = (key, payload = { options: {}, cookieType: itemType.ES }) => {
  const { options, cookieType } = payload;
  if (ssr.isOnClient) {
    return getCommonCookie(key, options, cookieType);
  }
  return ssr.cookies.getItem(key);
};

export const setCookie = (
  key,
  value,
  payload = {
    maxAge: 1, // in days
    path: '/',
    domain: '',
    secure: true,
    sameSite: 'none',
    isPiiData: false,
  }
) => {
  const { maxAge } = payload;
  const maxAgeInSeconds = Math.round(new Date().getTime() / 1000) + maxAge * 24 * 60 * 60;
  if (ssr.isOnClient) {
    setCommonCookie(key, value, {
      maxAge: 1, // in days
      path: '/',
      domain: '.makemytrip.com',
      secure: true,
      sameSite: 'none',
      isPiiData: false,
      ...payload,
      maxAge: maxAgeInSeconds,
    });
  } else {
    ssr.cookies.setItem(key, value, {
      ...payload,
      maxAge: maxAgeInSeconds,
    });
  }
};

export const removeCookie = (
  key,
  payload = {
    path: '/',
    domain: '',
  }
) => {
  removeCommonCookie(key, payload);
};
